enum AnalogPosition {
  Unknown = 0,
  Minimum = 1,
  Negative = 2,
  Neutral = 3,
  Positive = 4,
  Maximum = 5,
}

export default AnalogPosition;